import { render, staticRenderFns } from "./pickup-confirm.vue?vue&type=template&id=2d8f3579&scoped=true&"
import script from "./pickup-confirm.vue?vue&type=script&lang=js&"
export * from "./pickup-confirm.vue?vue&type=script&lang=js&"
import style0 from "./pickup-confirm.vue?vue&type=style&index=0&id=2d8f3579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f3579",
  null
  
)

export default component.exports